import React, { useEffect } from 'react';
import { Timeline, TimelineItem, TimelineSeparator, TimelineDot, TimelineConnector, TimelineContent } from '@mui/lab';
import { Typography } from '@mui/material';
import { Work, School, Code, Computer } from '@mui/icons-material';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useTranslation } from 'react-i18next';

import '../styles.css';

const AboutSection = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section id="about" className="about-section">
    
      {/* Título */}
      <h1 style={{ marginBottom: "40px" }} data-aos="fade-up">{t('aboutSection.title')}</h1>

      <div className="image-container"  data-aos="fade-up">
        <img 
          src="assets/foto-perfil.avif" 
          alt="Henry Vargas" 
          className="profile-image" 
          fit= "cover"
        />
      </div>

      {/* Descripción */}
      <p className="about-description" data-aos="fade-up">
        {t('aboutSection.description')}
      </p>

      <h1 data-aos="fade-up" >{t('aboutSection.educationExperience')}</h1>

      {/* Timeline de MUI */}
      <Timeline position="alternate" sx={{ fontSize: '1.2rem' }}>
        <TimelineItem data-aos="fade-up">
          <TimelineSeparator>
            <TimelineDot color="warning" sx={{ width: {xs: 35, md: 40}, height: {xs: 35, md: 40}, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Work style={{ color: 'white', fontSize: {xs: 25, md: 28} }} />
            </TimelineDot>
            <TimelineConnector sx={{ backgroundColor: '#40e0d0', borderRadius: "20px", width: {xs: 4, md: 5} }} />
          </TimelineSeparator>
          <TimelineContent>
            <Typography variant="h5" color="white" fontSize={{xs:"18px", md:"24px"}} mb={0.5} fontWeight="bold">{t('aboutSection.work.title')}</Typography>
            <Typography variant="h6" color="white" mb={0.5} fontSize={{xs:"16px", md:"20px"}}>{t('aboutSection.work.company')}</Typography>
            <Typography variant="body2" color="orange"   mb={0.5}>{t('aboutSection.work.duration')}</Typography>
            <Typography variant="body1" color="white"  fontSize={{xs:"14px", md:"18px"}} sx={{ mt: 0.5 }}>
              {t('aboutSection.work.description')}
            </Typography>
          </TimelineContent>
        </TimelineItem>

        <TimelineItem data-aos="fade-up">
          <TimelineSeparator>
            <TimelineDot color="warning" sx={{ width: {xs: 35, md: 40}, height: {xs: 35, md: 40}, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Computer style={{ color: 'white', fontSize: {xs: 25, md: 28} }} />
            </TimelineDot>
            <TimelineConnector sx={{ backgroundColor: '#40e0d0', borderRadius: "20px", width: {xs: 4, md: 5} }} />
          </TimelineSeparator>
          <TimelineContent>
            <Typography variant="h5" color="white" fontWeight="bold" mb={0.5} fontSize={{xs:"18px", md:"24px"}}>{t('aboutSection.education.title')}</Typography>
            <Typography variant="h6" color="white" mb={0.5} fontSize={{xs:"16px", md:"20px"}}>{t('aboutSection.education.institution')}</Typography>
            <Typography variant="body2" color="orange"  mb={0.5}>{t('aboutSection.education.duration')}</Typography>
            <Typography variant="body1" color="white"  fontSize={{xs:"14px", md:"18px"}} sx={{ mt: 0.5 }}>
              {t('aboutSection.education.description')}
            </Typography>
          </TimelineContent>
        </TimelineItem>

        <TimelineItem data-aos="fade-up">
          <TimelineSeparator>
            <TimelineDot color="warning" sx={{ width: {xs: 35, md: 40}, height: {xs: 35, md: 40}, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Code style={{ color: 'white', fontSize: {xs: 25, md: 28} }} />
            </TimelineDot>
            <TimelineConnector sx={{ backgroundColor: '#40e0d0', borderRadius: "20px", width: {xs: 4, md: 5} }} />
          </TimelineSeparator>
          <TimelineContent>
            <Typography variant="h5" color="white" fontWeight="bold" mb={0.5} fontSize={{xs:"18px", md:"24px"}}>{t('aboutSection.diploma.title')}</Typography>
            <Typography variant="h6" color="white" mb={0.5} fontSize={{xs:"16px", md:"20px"}}>{t('aboutSection.diploma.institution')}</Typography>
            <Typography variant="body2" color="orange"   mb={0.5}>{t('aboutSection.diploma.duration')}</Typography>
            <Typography variant="body1" color="white"  fontSize={{xs:"14px", md:"18px"}} sx={{ mt: 0.5 }}>
              {t('aboutSection.diploma.description')}
            </Typography>
          </TimelineContent>
        </TimelineItem>

        <TimelineItem data-aos="fade-up">
          <TimelineSeparator>
            <TimelineDot color="warning" sx={{ width: {xs: 35, md: 40}, height: {xs: 35, md: 40}, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <School style={{ color: 'white', fontSize: {xs: 25, md: 28} }} />
            </TimelineDot>
          </TimelineSeparator>
          <TimelineContent>
            <Typography variant="h5" color="white" fontWeight="bold" mb={0.5} fontSize={{xs:"18px", md:"24px"}}>{t('aboutSection.highSchool.title')}</Typography>
            <Typography variant="h6" color="white" mb={0.5} fontSize={{xs:"16px", md:"20px"}}>{t('aboutSection.highSchool.institution')}</Typography>
            <Typography variant="body2" color="orange"  mb={0.5}>{t('aboutSection.highSchool.duration')}</Typography>
            <Typography variant="body1" color="white"  fontSize={{xs:"14px", md:"18px"}} sx={{ mt: 0.5 }}>
              {t('aboutSection.highSchool.description')}
            </Typography>
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    </section>
  );
};

export default AboutSection;
